import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import {
  AnonymousConsentsModule,
  AuthModule,
  CostCenterOccModule,
  ExternalRoutesModule,
  I18nModule,
  ProductModule,
  ProductOccModule,
  UserOccModule,
} from '@spartacus/core'
import {
  AnonymousConsentManagementBannerModule,
  AnonymousConsentsDialogModule,
  BannerCarouselModule,
  BannerModule,
  CategoryNavigationModule,
  CmsParagraphModule,
  ConsentManagementModule,
  DIALOG_TYPE,
  HamburgerMenuModule,
  HomePageEventModule,
  IconModule,
  LinkModule,
  LoginRouteModule,
  LogoutModule,
  MyCouponsModule,
  MyInterestsModule,
  NavigationEventModule,
  NavigationModule,
  NotificationPreferenceModule,
  PaymentMethodsModule,
  ProductCarouselModule,
  ProductDetailsPageModule,
  ProductImagesModule,
  ProductIntroModule,
  ProductListModule,
  ProductListingPageModule,
  ProductPageEventModule,
  ProductReferencesModule,
  ProductSummaryModule,
  ProductTabsModule,
  SpinnerModule,
  StockNotificationModule,
} from '@spartacus/storefront'
import { OrderOccModule } from '@spartacus/order/occ'
import { RouterModule } from '@angular/router'
import { CheckoutRootModule } from '@spartacus/checkout/base/root'
//import { ProductConfiguratorFeatureModule } from './features/product-configurator/product-configurator-feature.module'
import { OrderApprovalRootModule } from '@spartacus/organization/order-approval/root'
import { AdministrationRootModule } from '@spartacus/organization/administration/root'
import { AddToWishListModule } from '@spartacus/cart/wish-list/components/add-to-wishlist'
import { FeaturesModule } from './features/features.module'

@NgModule({
  declarations: [],
  imports: [
    // Auth Core
    AuthModule.forRoot(),
    LogoutModule,
    LoginRouteModule,
    // Basic Cms Components
    HamburgerMenuModule,
    LinkModule,
    BannerModule,
    CmsParagraphModule,
    BannerCarouselModule,
    CategoryNavigationModule,
    NavigationModule,
    // User Core,
    // User UI,

    PaymentMethodsModule,
    NotificationPreferenceModule,
    MyInterestsModule,
    StockNotificationModule,
    ConsentManagementModule,
    MyCouponsModule,
    // Anonymous Consents Core,
    AnonymousConsentsModule.forRoot(),
    // Anonymous Consents UI,
    AnonymousConsentsDialogModule,
    AnonymousConsentManagementBannerModule,
    // Product Core,
    ProductModule.forRoot(),
    ProductOccModule,
    // Product UI,
    ProductDetailsPageModule,
    ProductListingPageModule,
    ProductListModule,

    ProductTabsModule,
    ProductCarouselModule,
    ProductReferencesModule,
    ProductImagesModule,
    ProductSummaryModule,
    ProductIntroModule,
    // Cart Core,
    // Cart UI,
    AddToWishListModule,
    CostCenterOccModule,
    // Order,
    OrderOccModule,
    // Page Events,
    NavigationEventModule,
    HomePageEventModule,
    ProductPageEventModule,
    // External routes,
    ExternalRoutesModule.forRoot(),
    IconModule,
    SpinnerModule,
    I18nModule,
    RouterModule,
    CheckoutRootModule,
    UserOccModule,
    AdministrationRootModule,
    OrderApprovalRootModule,
    FeaturesModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [SpinnerModule, I18nModule],
  providers: [],
})
export class SpartacusFeaturesModule {}
